{
  "el": {
    "survey": {
      "actions": {
        "add": "Προσθήκη νέου",
        "addDescription": "Προσθήκη περιγραφής",
        "close": "Κλείσιμο",
        "create": "Δημιουργία",
        "createNew": "Δημιουργία",
        "delete": "Διαγραφή",
        "deleteCount": "Πρόκειται να διαγράψεις {count} ερωτηματολόγιο. Θέλεις σίγουρα να συνεχίσεις; | Πρόκειται να διαγράψεις {count} ερωτηματολόγια. Θέλεις σίγουρα να συνεχίσεις;",
        "deleteMultiple": "Διαγραφή...",
        "delete_cancel": "Ακύρωση",
        "delete_surveys": "Διαγραφή ερωτηματολογίου | Διαγραφή ερωτηματολογίων",
        "importTemplate": "Εισαγωγή",
        "newSurvey": "Ερωτηματολόγιο",
        "publish": "Δημοσίευση",
        "publishCustomer": "Δημοσίευση για πελάτες",
        "revokeAccess": "Ανάκληση πρόσβασης",
        "save": "Αποθήκευση",
        "selectAll": "Επιλογή και των {total} ερωτηματολογίων",
        "send": "Αποστολή",
        "sendCustomer": "Αποστολή στον πελάτη",
        "submit": "Υποβολή",
        "surveys_collapse": "Σύμπτυξη ερωτηματολογίων",
        "surveys_expand": "Ανάπτυξη ερωτηματολογίων",
        "unSelectAll": "Εκκαθάριση επιλογής.",
        "unpublish": "Κατάργηση δημοσίευσης"
      },
      "attributes": {
        "description": "Εσωτερικός τίτλος",
        "title": "Η ερώτησή σου"
      },
      "labels": {
        "NPSOverview": "Επισκόπηση NPS",
        "NPSQuestion": "Πόσο πιθανό είναι να συστήσεις «{name}» σε έναν φίλο ή συνάδελφο;",
        "addQuestion": "Ερώτηση",
        "allUnitsAssigned": "Όλα τα ακίνητα έχουν ανατεθεί",
        "answerRequired": "Απάντηση (υποχρεωτικό)",
        "answer_later": "Απάντηση αργότερα",
        "answeredAt": "Απαντήθηκε στις",
        "average_score": "Μέση βαθμολογία",
        "clientTeam": "Η ομάδα «{name}»",
        "comments": "Σχόλια ή προτάσεις; (προαιρετικό)",
        "completedTime": "Απαντήθηκε",
        "customer": "Πελάτης",
        "customer_status": "Κατάσταση",
        "detractors": "Επικριτές",
        "dissatisfied": "Χαμηλή ικανοποίηση",
        "extremelyLikely": "Πολύ πιθανό",
        "lets_go": "Ας ξεκινήσουμε",
        "list": "Λίστα",
        "mostRecentAnswers": "Πιο πρόσφατες απαντήσεις",
        "neither_satisfied_nor_dissatisfied": "Ούτε χαμηλή ούτε υψηλή ικανοποίηση",
        "neutrals": "Ουδέτεροι",
        "noAnswers": "Δεν υπάρχουν απαντήσεις ακόμα",
        "noSurveyFeedback": "Δεν υπάρχουν σχόλια ή προτάσεις",
        "noSurveysYet": "Δεν υπάρχουν ερωτηματολόγια ακόμα. Δημιούργησε το πρώτο σου ερωτηματολόγιο για να ξεκινήσεις.",
        "noUnitsClick": "Δεν υπάρχουν ακίνητα ακόμα, κάνε κλικ εδώ για να προσθέσεις",
        "no_opinion": "Χωρίς άποψη",
        "notAtAllLikely": "Καθόλου πιθανό",
        "nps": "NPS",
        "numberAnswered": "{answered} από {total} απαντήσεις",
        "obligatory": "Υποχρεωτικό ερωτηματολόγιο για πελάτες",
        "pendingSurveys": " Χρειαζόμαστε τα σχόλιά σου",
        "promoters": "Υποστηρικτές",
        "publishNow?": "Δημοσίευση τώρα;",
        "published": "Δημοσιευμένο",
        "publishedCount": "Δημοσίευση αυτού του ερωτηματολογίου σε πελάτη | Δημοσίευση {count} ερωτηματολογίων σε πελάτες",
        "question": "Ερώτηση",
        "question_number": "Ερώτηση {current_number} από {total_questions}",
        "questions": "Ερωτήσεις",
        "respondents": "Κανένας συμμετέχων | 1 συμμετέχων | {count} συμμετέχοντες",
        "response": "Απάντηση",
        "responseTime": "Χρόνος απάντησης",
        "responses": "Απαντήσεις",
        "revokeAccessCount": "Ανάκληση πρόσβασης σε αυτό το ερωτηματολόγιο για τον πελάτη | Ανάκληση πρόσβασης σε αυτό το ερωτηματολόγιο για {count} πελάτες",
        "satisfied": "Υψηλή ικανοποίηση",
        "saveExplainer": "Θέλεις να κάνεις αυτό το ερωτηματολόγιο ορατό στους πελάτες σου; Ή να το αποθηκεύσεις και να το δημοσιεύσεις αργότερα;",
        "scoreBreakdown": "Ανάλυση βαθμολογίας",
        "selectOneUnit": "Επίλεξε τουλάχιστον 1 ερωτηματολόγιο",
        "selectUnits": "Επιλογή ακινήτων",
        "selected": "Επιλέχθηκε {selected} ερωτηματολόγιο. | Επιλέχθηκαν {selected} ερωτηματολόγια.",
        "sendCount": "Αποστολή αυτού του ερωτηματολογίου σε πελάτη | Αποστολή ερωτηματολογίων σε {count} πελάτες",
        "sendExplainer": "Οι πελάτες σου θα το δουν στην αρχική τους σελίδα",
        "sendNow?": "Αποστολή τώρα;",
        "sent": "Στάλθηκε",
        "sentCustomer": "Στάλθηκε στον πελάτη",
        "showSurveysFor": "Εμφάνιση ερωτηματολογίων για",
        "showingResultsFor": "Εμφάνιση αποτελεσμάτων για",
        "step0Title": "Ποιο πρότυπο έργο και ερωτηματολόγιο θέλεις να χρησιμοποιήσεις;",
        "step2Subtitle": "Έτσι οι πελάτες σου θα ξέρουν ποιος είναι ο σκοπός αυτού του ερωτηματολογίου",
        "step2Title": "Πρόσθεσε έναν σύντομο πρόλογο",
        "step3Subtitle": "Επίλεξε το έργο σου για να συμπεριλάβεις όλα τα ακίνητά σου ταυτόχρονα.",
        "step3Title": "Για ποια ακίνητα θέλεις να δημιουργήσεις αυτό το ερωτηματολόγιο;",
        "survey": "Ερωτηματολόγιο",
        "surveyAlreadyAnswered": "Το ερωτηματολόγιο έχει ήδη απαντηθεί. Ευχαριστούμε για τα σχόλιά σου.",
        "surveyAnswer": "Σχόλια",
        "surveyNotCompleted": "Το ερωτηματολόγιο δεν έχει ολοκληρωθεί ακόμα.",
        "surveys": "Ερωτηματολόγια",
        "surveysCount": "{count} ερωτηματολόγιο | {count} ερωτηματολόγια",
        "surveys_all_projects": "Ερωτηματολόγια όλων των έργων",
        "tabOverview": "Επισκόπηση",
        "tabSurveys": "Ερωτηματολόγια",
        "thankYou": "Ευχαριστούμε για τα σχόλιά σου.",
        "title": "Ερώτηση",
        "titles_must_be_unique": "Υπάρχουν διπλότυπες ερωτήσεις. Οι ερωτήσεις πρέπει να είναι μοναδικές.",
        "totalSelected": "Έχουν επιλεγεί και τα {total} ερωτηματολόγια.",
        "unanswered": "Αναπάντητο",
        "unit": "Ακίνητο",
        "unitSelected": "Δεν έχει επιλεγεί ακόμη ακίνητο | Επιλέχθηκε ένα ακίνητο | Επιλέχθηκαν {count} ακίνητα",
        "units": "Ακίνητα",
        "unitsWithoutSurvey": "{count} ακίνητο χωρίς ερωτηματολόγιο | {count} ακίνητα χωρίς ερωτηματολόγιο",
        "unpublishedCount": "Κατάργηση δημοσίευσης αυτού του ερωτηματολογίου | Κατάργηση δημοσίευσης {count} ερωτηματολογίων",
        "very_dissatisfied": "Πολύ χαμηλή ικανοποίηση",
        "very_satisfied": "Πολύ υψηλή ικανοποίηση",
        "visibility": "Ορατότητα",
        "yourAnswers": "Οι απαντήσεις σου",
        "yourQuestion": "Η ερώτησή σου"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Ζήτησε σχόλια από τους πελάτες σου",
            "title": "Δημιούργησε το πρώτο σου ερωτηματολόγιο"
          },
          "none": {
            "subtitle": "Ζήτησε σχόλια από τους πελάτες σου",
            "title": "Δεν βρέθηκαν ερωτηματολόγια"
          }
        }
      },
      "toasts": {
        "bulk_create": "Το ερωτηματολόγιο δημιουργήθηκε με επιτυχία | Τα ερωτηματολόγια δημιουργήθηκαν με επιτυχία",
        "bulk_delete": "Το ερωτηματολόγιο διαγράφηκε με επιτυχία | Τα ερωτηματολόγια διαγράφηκαν με επιτυχία",
        "bulk_update": "Το ερωτηματολόγιο ενημερώθηκε με επιτυχία | Τα ερωτηματολόγια ενημερώθηκαν με επιτυχία",
        "update": "Το ερωτηματολόγιο ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "needName": "Γράψε μια ερώτηση",
        "needQuestion": "Πρόσθεσε τουλάχιστον 1 ερώτηση",
        "selectUnit": "Επίλεξε τουλάχιστον 1 ακίνητο"
      }
    }
  }
}
